export type Language = {
  code: string;
  flag: string;
  translationKey: string;
};

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', flag: '🇬🇧', translationKey: 'language.english' },
  { code: 'es', flag: '🇪🇸', translationKey: 'language.spanish' },
  { code: 'fr', flag: '🇫🇷', translationKey: 'language.french' },
  { code: 'de', flag: '🇩🇪', translationKey: 'language.german' },
  { code: 'pt-BR', flag: '🇧🇷', translationKey: 'language.portuguese' },
  { code: 'ru', flag: '🇷🇺', translationKey: 'language.russian' },
];

// Коды языков для проверки
export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);
